export default __webpack_public_path__ + "static/media/The Rock.3f143a71.jpg";